// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2bd7f9de","453":"57b7c417","455":"92fa86b2","977":"6f894dca"}[chunkId] + ".chunk.js";
};